module.exports = __webpack_public_path__ + "img/rodina.d51c0746.svg";